import React from "react";

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`bg-[#0F1E2C]/85 border border-[#FFD166]/25 rounded-2xl backdrop-blur ${className}`} {...rest}>{children}</div>
);

export const Btn = ({ children, className = "", variant = "primary", ...p }) => {
  const base = "px-4 py-2 rounded-full text-sm font-medium transition-all inline-flex items-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed disabled:pointer-events-none";
  const styles = {
    primary: "bg-gradient-to-r from-[#D97B37] to-[#F4A93A] text-[#1a0a03] hover:brightness-110 shadow-[0_4px_20px_rgba(217,123,55,0.35)]",
    ghost: "border border-[#FFD166]/40 text-[#FFD166] hover:bg-[#FFD166]/10",
    danger: "border border-red-500/40 text-red-400 hover:bg-red-500/10",
  };
  return <button className={`${base} ${styles[variant]} ${className}`} {...p}>{children}</button>;
};

export const Input = React.forwardRef(({ className = "", ...p }, ref) => (
  <input ref={ref} {...p} className={`w-full bg-black/30 border border-[#FFD166]/25 text-[#F6F1E4] px-3 py-2 rounded-lg focus:outline-none focus:border-[#FFD166] ${className}`} />
));

export const Field = ({ label, hint, children }) => (
  <div>
    <label className="text-xs uppercase tracking-[0.2em] text-[#B9C8D5]">{label}</label>
    <div className="mt-1">{children}</div>
    {hint && <p className="text-[10px] text-[#B9C8D5]/60 mt-1">{hint}</p>}
  </div>
);
